import { render, staticRenderFns } from "./DropdownMenuFilter.vue?vue&type=template&id=027bcf74&"
import script from "./DropdownMenuFilter.vue?vue&type=script&lang=js&"
export * from "./DropdownMenuFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports